import script from "./ingredient-tag-input.vue?vue&type=script&setup=true&lang=js"
export * from "./ingredient-tag-input.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__